/**
 * Created by carlhaynes on 9/28/17.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Panel } from 'react-bootstrap';


class CollectorItem extends Component {

  constructor(props) {
    super(props);
    console.log(props);
  }

  componentWillMount() {
    console.log("CollectorItem componentWillMount");
  }


  render() {

    console.log("render CollectorItem");
    console.log(this.props.collector.email);

    var divStyle = {
      background: "#eee",
      padding: "20px",
      margin: "20px",
      border: "1px solid black"
    };


    let collector = this.props.collector;
    return (
      <Col xs={6} md={4}>
        <Panel header={collector.email}>
          <div style={divStyle}>
          Panel content
          </div>
        </Panel>
      </Col>
    );
  }
}

CollectorItem.propTypes = {
  collector: PropTypes.object
};

export default CollectorItem;



// WEBPACK FOOTER //
// ./src/Components/CollectorItem.jsx